import React from 'react';
import PropTypes from 'prop-types';
import T from '@prisjakt/ui-translate';

import * as S from './styles';

const StoreLink = React.memo(({ link, name }) =>
  link && name ? (
    <S.StoreInfoLink to={link} data-test="StoreInfoLink">
      <T domain="product" store_name={name}>
        store-info.more-about-store
      </T>
    </S.StoreInfoLink>
  ) : null
);

StoreLink.propTypes = {
  link: PropTypes.string,
  name: PropTypes.string,
};

StoreLink.defaultProps = {
  link: undefined,
  name: undefined,
};

export default StoreLink;
